
<div
	class="application-widget"
	:effects="effects"
	:tabindex="tabindex"
	@click="handleClick($event)"
>
	<div class="application-widget-header flex-gap-8">
		<!--@slot Used for Header Data -->
		<slot name="application-header" />
	</div>
	<div
		v-if="$slots['application-body']"
		class="application-widget-body"
		:class="hoverEffect ? 'add-hover' : ''"
	>
		<!-- @slot Used for Stats Data -->
		<slot name="application-body" />
	</div>

	<div class="application-widget-footer">
		<!--@slot Used for Footer Data -->
		<slot name="application-footer" />
	</div>
</div>
